import { useDispatch } from "react-redux";
import { 
    useLoginWithTelegramMutation,
    useLoginWithTelegramWidgetMutation
} from "../api/authApi";
import { useTokenRefresh } from "./useTokenRefresh";
import { setAuthLoading, setAuthError, setAuthSucceeded } from "../../../app/store/authSlice";
import { setAccessToken, setRefreshToken } from '../../../app/utils/authStorage';


export const useAuth = () => {
    const dispatch = useDispatch();
    const [loginMutation] = useLoginWithTelegramMutation();
    const [loginWithWidgetMutation] = useLoginWithTelegramWidgetMutation();

    const loginWithTelegram = async () => {
        if (!window.Telegram?.WebApp?.initData) {
            console.error('Telegram WebApp not initialized');
            return;
        }
        
        try {
            dispatch(setAuthLoading());
            const result = await loginMutation(window.Telegram.WebApp.initData);
            if (result.error) {
                throw new Error(result.error.data?.message || 'Auth failed');
            }
            if (result && result.data) {
                setAccessToken(result.data.access_token);
                setRefreshToken(result.data.refresh_token);
            }
            dispatch(setAuthSucceeded());
            return result;
        } catch (error) {
            const message = error.message || 'Unknown error';
            dispatch(setAuthError(message));
            throw error;
        }
    };

    const loginWithTelegramWidget = async (telegramData) => {
        if (!telegramData?.id || !telegramData?.hash) {
            console.error('Invalid Telegram widget data');
            return;
        }

        try {
            dispatch(setAuthLoading());
            const result = await loginWithWidgetMutation(telegramData);
            if (result.error) {
                throw new Error(result.error.data?.message || 'Auth failed');
            }
            if (result.data) {
                setAccessToken(result.data.access_token);
                setRefreshToken(result.data.refresh_token);
            }
            dispatch(setAuthSucceeded());
            return result;
        } catch (error) {
            const message = error.message || 'Unknown error';
            dispatch(setAuthError(message));
            throw error;
        }
    };

    useTokenRefresh();

    return {
        loginWithTelegram,
        loginWithTelegramWidget
    };
};
